module.exports = __webpack_public_path__ + "static/media/dest2.b948c037.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/tepual/destinations/dest2.jpg
// module id = 1668
// module chunks = 0